// Modules
import React from 'react';
import i18n from 'i18n-react';

const SearchResultItems = (props) => {
    let content = null;

    if (props.items.length > 0) {
        const items = props.items.map((item) => (
            <li key={item.id}
                value={item.id}
                className={item.type ? `dropdown-item administration-type ${item.type} ${item.onlineStatus}` : 'dropdown-item'}
                onClick={() => props.onSelect(item)}>
                {item.name}
            </li>
        ));

        // Show text with the amount of more results than the ones that already shown
        let moreResults = null;
        if (props.amountOfMoreResults > 0) {
            moreResults = (
                <li className="dropdown-item no-hover more-results" onClick={props.onClickMoreResults}>
                    {i18n.translate('searchResult.andMoreResults', { amountOfResults: props.amountOfMoreResults })}
                </li>
            );
        }

        content = (
            <div className="dropdown-items">
                <li className="dropdown-header">{props.header}</li>
                {items}
                {moreResults}
            </div>
        );
    }

    return content;
};

export default SearchResultItems;
